import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import {
  boostLocationRoute,
  enterpriseBoostLocationRoute,
} from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';
import { paymentDetails } from '@features/payments';

type useEnterpriseBoostLocationProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useEnterpriseBoostLocation = ({
  setErrorText,
}: useEnterpriseBoostLocationProps) => {
  const client = useQueryClient();

  const {
    mutate: boostEnterpriseLocation,
    isLoading: isBoostEnterpriseLocationLoading,
  } = useMutation({
    mutationFn: (variables: {
      number_weeks: number;
      company_id: number | string | undefined;
      token?: string;
    }) =>
      axiosInstance
        .post(enterpriseBoostLocationRoute, variables)
        .then((res) => res.data),

    onMutate: () => {
      setErrorText('');
    },

    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries([paymentDetails]);
        setErrorText('');
      }
    },
    onError: (error: { response?: { data?: { message?: string } } }) => {
      setErrorText(error?.response?.data?.message || errorMessage);
    },
  });

  return {
    boostEnterpriseLocation,
    isBoostEnterpriseLocationLoading,
  };
};
